import React from "react";
import Section from "../template/Section";

export default () => <Section />;
